import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReduxBlockUi from 'react-block-ui/redux';
import { Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import FontAwesome from 'react-fontawesome';
import Calendar, { getDefaultCalendarView, dateRangeByView, selectableDateRangeByView } from '../../dashboard/booking/calendarView/Calendar';
import BookingOptions from '../../dashboard/booking/calendarView/BookingOptions';
import TimetableSearchForm from './TimetableSearchForm';
import queryString from 'query-string';
import { withTranslation } from 'react-i18next';
import { updateSelectedCenter } from '../../dashboard/actions';
import {
	loadLessons,
	loadTermsByCenter, loadGradesByCenter,
	SELECTED_CENTER_LESSONS_REQUEST, SELECTED_CENTER_LESSONS_SUCCESS, SELECTED_CENTER_LESSONS_FAILURE
} from '../../dashboard/common/actions';
import {
	storeSearchQuery, loadBookingOptions, unselectLesson, selectPaymentType, selectChild, startEnrolment, selectJoinWaitingList,
	BOOKING_OPTIONS_FETCH_REQUEST, BOOKING_OPTIONS_FETCH_SUCCESS, BOOKING_OPTIONS_FETCH_FAILURE
} from '../../dashboard/booking/actions';
import {
	loadAgeAppropriateGradesByCenterAndTerm, getAgeAppropriateGradesByChild,
	CHILDREN_GRADES_REQUEST, CHILDREN_GRADES_SUCCESS, CHILDREN_GRADES_FAILURE
} from '../../dashboard/actions';
import { getChild } from '../../dashboard/reducer';
import analyticsTracker, { AnalyticsPlatforms } from '../../common/services/analyticsTracker';
import moment from 'moment';
import { getActiveLanguage } from '../../languages/reducer';
import utils from '../../common/services/utils';
import availabilityUtils from '../../dashboard/booking/availabilityUtils';
import RecommendedNearbyCenters from '../../dashboard/booking/RecommendedNearbyCenters';

class Timetable extends Component {
	constructor(props) {
		super(props);

		this.handleCitySelect = this.handleCitySelect.bind(this);
		this.handleCenterSelect = this.handleCenterSelect.bind(this);
		this.handleTermSelect = this.handleTermSelect.bind(this);
		this.handleGradesSelect = this.handleGradesSelect.bind(this);

		this.handleCalendarNavigate = this.handleCalendarNavigate.bind(this);
		this.handleCalendarLessonSelect = this.handleCalendarLessonSelect.bind(this);
		this.handleLessonUnselect = this.handleLessonUnselect.bind(this);

		this.handlePaymentTypeSelect = this.handlePaymentTypeSelect.bind(this);
		this.handleBookingOptionsConfirm = this.handleBookingOptionsConfirm.bind(this);
		this.handleJoinWaitingList = this.handleJoinWaitingList.bind(this);
	}

	componentDidMount() {
		this.reloadData(this.props);
		this.props.storeSearchQuery(this.props.location.search);
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.terms.length > 0 && !this.props.searchParams.termId) {
			// init with the first available term
			this.handleTermSelect(nextProps.terms[0].id, true, nextProps.terms);
		}
		if (!nextProps.searchParams.centerId && !nextProps.searchParams.city && nextProps.centers.length > 0) {
			if (nextProps.centers.length === 1) {
				this.handleCenterSelect(nextProps.centers[0].id, true, nextProps.centers);
			}
			else if (nextProps.parentCenter) {
				// init with parent's selected center if parent is logged in
				this.handleCenterSelect(nextProps.parentCenter.id, true, nextProps.centers);
			}
		}

		if (nextProps.searchParams.termId && nextProps.terms.length > 0 && !nextProps.searchParams.date) {
			// set default dates for the selected term
			this.handleTermSelect(nextProps.searchParams.termId, true, nextProps.terms);
		}

		// all search params are in the query string, reload lessons when query string changes
		if (this.props.location.search !== nextProps.location.search) {
			this.props.storeSearchQuery(nextProps.location.search);

			const currentQueryParams = queryString.parse(this.props.location.search);
			const nextQueryParams = queryString.parse(nextProps.location.search);
			if (currentQueryParams.centerId !== nextQueryParams.centerId ||
				currentQueryParams.termId !== nextQueryParams.termId ||
				//this.convertGradeIdsToSortedString(currentQueryParams.gradeIds) !== this.convertGradeIdsToSortedString(nextQueryParams.gradeIds) ||
				currentQueryParams.date !== nextQueryParams.date) {
				this.reloadCenterData(nextProps);
				this.reloadLessons(nextProps);
				this.reloadAgeAppropriateGrades(nextProps);
			}

			// reload booking options when lesson is selected
			if (currentQueryParams.programId !== nextQueryParams.programId ||
				currentQueryParams.startDate !== nextQueryParams.startDate) {
				this.reloadBookingOptions(nextProps);
			}
		}

		// load lessons after centers are loaded to have access to allowFutureBooking property
		if (((!this.props.selectedCenter || !this.props.selectedCenter.name) && nextProps.selectedCenter && nextProps.selectedCenter.name) ||
			this.props.terms.length === 0 && nextProps.terms.length > 0) {
			this.reloadLessons(nextProps);
		}

		// reload age appropriate grades when current parent is loaded
		if (!this.props.parent.id && nextProps.parent.id) {
			this.reloadAgeAppropriateGrades(nextProps);
		}
	}

	convertGradeIdsToSortedString(value) {
		if (!Array.isArray(value))
			return value;

		return value.sort((a, b) => Number(a) - Number(b)).join(',');
	}

	reloadData(props) {
		this.reloadCenterData(props);
		this.reloadLessons(props);
		this.reloadBookingOptions(props);
		this.reloadAgeAppropriateGrades(props);
	}

	reloadCenterData(props) {
		const { searchParams: { centerId }, loadTermsByCenter, loadGradesByCenter } = props;
		if (centerId) {
			loadTermsByCenter(centerId);
			loadGradesByCenter(centerId);
		}
	}

	reloadLessons(props) {
		const { searchParams: { centerId, termId, gradeIds, date, lessonType }, selectedCenter, loadLessons, t, franchisor, centers } = props;
		const selectedTerm = props.terms.find(x => x.id === termId);

		if (date && selectedCenter && selectedTerm) {
			document.title = t('FO_Document_Title_Book', { center: selectedCenter.name, term: selectedTerm.name });

			const initialDateForTerm = this.getCalendarInitialDateForTerm(selectedTerm);
			const canNavigate = selectedCenter.allowFutureBooking || lessonType === 'makeup';
			const calendarViewName = getDefaultCalendarView(canNavigate);
			const selectableDateRange = selectableDateRangeByView(calendarViewName, initialDateForTerm);
			if (!canNavigate && ((selectableDateRange.from && moment(date) < moment(selectableDateRange.from).startOf('day')) ||
				(selectableDateRange.to && moment(date) > moment(selectableDateRange.to).startOf('day')))) {
				// replace selected date with today or term's start date if center doesn't allow bookings in the future
				this.updateSearchParams({ date: moment(initialDateForTerm).format('YYYY-MM-DD') }, true);
			} else {
				const { from, to } = dateRangeByView(calendarViewName, date, this.getStartOfTermWeekday(selectedTerm));
				// load program for selected center
				loadLessons(centerId, termId, null, from, to, null, true);

				// load program for nearby centers
				if (franchisor.recommendNearbyCenters) {
					const closestCenters = utils.findClosestCenters(selectedCenter, centers, franchisor.distanceToNearbyCenters);
					closestCenters.forEach(center => {
						loadLessons(center.id, termId, null, from, to, null, false);
					});
				}
			}
		}
	}

	reloadAgeAppropriateGrades(props) {
		const { searchParams: { centerId, termId }, parent, loadAgeAppropriateGradesByCenterAndTerm } = props;
		if (centerId && termId && parent.id > 0) {
			loadAgeAppropriateGradesByCenterAndTerm(centerId, termId);
		}
	}

	reloadBookingOptions(props) {
		const { searchParams: { centerId, lessonType, programId, startDate }, loadBookingOptions, unselectLesson } = props;

		if (programId && startDate) {
			loadBookingOptions({
				programId,
				date: startDate,
				childId: 0,//this.props.bookingOptions.selectedChildId,
				lessonType: lessonType,
				centerId: centerId
			});
		} else {
			unselectLesson();
		}
	}

	updateSearchParams(newParam, replaceHistory) {
		const { searchParams, location, history } = this.props;

		const newSearchParams = Object.assign(searchParams, newParam);

		const newPath = {
			pathname: location.pathname,
			search: queryString.stringify(newSearchParams)
		};

		if (replaceHistory) {
			history.replace(newPath);
		} else {
			history.push(newPath);
		}
	}

	handleCitySelect(city) {
		this.updateSearchParams({ city, centerId: null });
		this.handleLessonUnselect(true);

		const cityCenters = city ? this.props.centers.filter(x => x.city === city) : this.props.centers;
		if (cityCenters.length === 1) {
			this.handleCenterSelect(cityCenters[0].id, true);
		}
	}

	handleCenterSelect(centerId, replaceHistory, allCenters) {
		const selectedCenterId = Number(centerId);
		if (selectedCenterId) {
			const centers = allCenters || this.props.centers;
			const selectedCenter = centers.find(x => x.id === selectedCenterId);

			this.updateSearchParams({
				city: selectedCenter && selectedCenter.city,
				centerId: selectedCenterId
			}, replaceHistory);

			if (selectedCenter) {
				analyticsTracker.trackEvent('SelectedCentre', {
					name: selectedCenter.name
				});
			}

			if (this.props.parent.id > 0) { // update parent's center if parent is logged in
				this.props.updateSelectedCenter(selectedCenterId, this.props.history, false);
			}
			this.handleLessonUnselect(true);
		}
	}

	handleTermSelect(termId, replaceHistory, allTerms) {
		const selectedTermId = Number(termId);
		if (selectedTermId) {
			const terms = allTerms || this.props.terms;
			const selectedTerm = terms.find(x => x.id === selectedTermId);
			// move calendar to term start (or today if term has already started) before reload
			const calendarInitialDate = this.getCalendarInitialDateForTerm(selectedTerm);
			this.updateSearchParams({ termId: selectedTermId, date: moment(calendarInitialDate).format('YYYY-MM-DD') }, replaceHistory);

			this.handleLessonUnselect(true);
		}
	}

	handleGradesSelect(gradeIds) {
		this.updateSearchParams({ gradeIds });
	}

	handleCalendarNavigate(date) {
		this.updateSearchParams({ date: moment(date).format('YYYY-MM-DD') });
	}

	getCalendarInitialDateForTerm(term, minDate) {
		const today = new Date();
		if (!minDate) {
			minDate = today;
		}
		const startOfTerm = term ? new Date(term.startDate) : today;
		return minDate > startOfTerm ? minDate : startOfTerm;
	}

	getStartOfTermWeekday(term) {
		return term ? moment(term.startDate).isoWeekday() : 1;
	}

	handleCalendarLessonSelect(lesson) {
		analyticsTracker.trackEvent('view_item', {
			items: [
				{
					item_id: lesson.grade.id,
					item_name: lesson.grade.name,
					item_brand: lesson.center.name,
					item_category: `${lesson.term.name}, ${lesson.term.schoolYear}`
				}
			]

		}, AnalyticsPlatforms.GoogleAnalytics);

		this.updateSearchParams({ programId: lesson.programId, startDate: lesson.start });
	}

	handleLessonUnselect(replaceHistory) {
		this.updateSearchParams({ programId: null, startDate: null }, replaceHistory);
	}

	handlePaymentTypeSelect({ paymentTypeId, isPrepaid, isBonusLesson, annualPaymentLength }) {
		this.props.selectPaymentType({ paymentTypeId, isPrepaid, isBonusLesson, annualPaymentLength });
	}

	handleBookingOptionsConfirm() {
		const { franchisor, searchParams: { centerId, programId, startDate }, bookingOptions, selectedLesson } = this.props;
		const { selectedPaymentTypeId, selectedChildId, childrenPaymentTypes } = bookingOptions;
		const childPaymentOptions = childrenPaymentTypes.find(x => (!selectedChildId && !x.child) || x.child.id === selectedChildId);
		const paymentOptions = childPaymentOptions && childPaymentOptions.paymentTypes.find(x => x.id === selectedPaymentTypeId);

		this.props.startEnrolment({
			centerId, programId, startDate,
			paymentTypeId: selectedPaymentTypeId,
			currency: franchisor.currency,
			quantity: paymentOptions && paymentOptions.quantity,
			unitPrice: paymentOptions && paymentOptions.unitPriceAmount,
			total: paymentOptions && paymentOptions.totalAmount,
			lesson: selectedLesson
		});
		this.props.history.push('/register', { from: '/booking/child' });
	}

	handleJoinWaitingList() {
		this.props.selectJoinWaitingList();
		this.props.history.push('/register', { from: '/booking/child' });
	}

	render() {
		const { cities, centers, selectedCenter, terms, grades, lessons, franchisor, allowWorkshops, t } = this.props;
		const { city, centerId, termId, gradeIds, date, lessonType } = this.props.searchParams;

		const selectedCity = city;
		const selectedTerm = terms.find(x => x.id === termId);
		const selectedGrades = gradeIds ? grades.filter(grade => gradeIds.indexOf(grade.id) > -1) : [];
		const selectedDate = date && new Date(date);

		const initialDate = selectedTerm && this.getCalendarInitialDateForTerm(selectedTerm);

		const lessonsInSelectedCenterTermGrades = lessons.filter(x => x.centerId === centerId &&
			x.termId === termId &&
			(!gradeIds || gradeIds.indexOf(x.gradeId) > -1 || (x.grade.mixed && x.grade.subGrades && x.grade.subGrades.some(s => gradeIds.indexOf(s) > -1))));

		const alternativeCenters = (this.props.selectedLesson &&
			availabilityUtils.getLessonAvailability(this.props.selectedLesson, lessonType) === 'No' &&
			franchisor.recommendNearbyCenters &&
			availabilityUtils.findNearbyCentersWithAvailableSpotsByLesson(selectedCenter, this.props.selectedLesson, lessonType, centers, lessons, franchisor.distanceToNearbyCenters)) || [];

		return <div className='timetable-wrapper'>
			<ReduxBlockUi block={SELECTED_CENTER_LESSONS_REQUEST} unblock={[SELECTED_CENTER_LESSONS_SUCCESS, SELECTED_CENTER_LESSONS_FAILURE]}>
				<Row className={this.props.selectedLesson ? 'hidden-xs' : ''}>
					<Col md={12}>
						<TimetableSearchForm
							cities={cities}
							centers={centers}
							terms={terms}
							grades={grades.filter(x => !x.mixed)}
							selectedCity={selectedCity}
							selectedCenter={selectedCenter}
							selectedTerm={selectedTerm}
							selectedGrades={selectedGrades}
							onSelectCity={this.handleCitySelect}
							onSelectCenter={this.handleCenterSelect}
							onSelectTerm={this.handleTermSelect}
							onSelectGrades={this.handleGradesSelect}
							franchisorDisplayName={franchisor.displayName}
						/>
					</Col>
				</Row>
				<Row>
					<Col md={12} style={{ marginTop: '30px' }}>
						<div className={this.props.selectedLesson ? 'calendar-container hidden-xs' : 'calendar-container'}>
							<Calendar date={selectedDate}
								startOfWeek={this.getStartOfTermWeekday(selectedTerm)}
								canNavigate={(selectedCenter ? selectedCenter.allowFutureBooking : true) || lessonType === 'makeup'}
								initialDate={initialDate}
								lessonType={lessonType}
								lessons={lessonsInSelectedCenterTermGrades}
								enableUserTimeZone={franchisor.enableUserTimeZone}
								center={selectedCenter}
								onNavigate={this.handleCalendarNavigate}
								onSelectLesson={this.handleCalendarLessonSelect}

							/>
						</div>
						<div className={!this.props.selectedLesson ? (this.props.parent.id > 0 ? 'booking-options-container hidden-xs' : 'hidden') : 'booking-options-container'} >
							<BookingOptions
								children={this.props.children}
								selectedLesson={this.props.selectedLesson}
								enableUserTimeZone={franchisor.enableUserTimeZone}
								bookingOptions={this.props.bookingOptions}
								onCancel={this.handleLessonUnselect}
								onSelectPaymentType={this.handlePaymentTypeSelect}
								onSelectChild={this.props.selectChild}
								onConfirm={this.handleBookingOptionsConfirm}
								onJoinWaitingList={this.handleJoinWaitingList}
								block={BOOKING_OPTIONS_FETCH_REQUEST}
								unblock={[BOOKING_OPTIONS_FETCH_SUCCESS, BOOKING_OPTIONS_FETCH_FAILURE]}
								blockChildrenInfo={CHILDREN_GRADES_REQUEST}
								unblockChildrenInfo={[CHILDREN_GRADES_SUCCESS, CHILDREN_GRADES_FAILURE]}
								enableCurrencyConversion={franchisor.enableCurrencyConversion}
								enableAnnualSubscriptionInstalments={franchisor.enableAnnualSubscriptionInstalments}
								currentCurrency={this.props.currentCurrency}
								franchisorCurrency={franchisor.currency}
								isAuthenticated={this.props.isAuthenticated}
								selectedTerm={selectedTerm}
								centerId={centerId}
							/>
						</div>
						{alternativeCenters.length > 0 && <div className='booking-options-container' style={{ background: 'none', border: 'none', boxShadow: 'none' }}>
							<RecommendedNearbyCenters
								centers={alternativeCenters}
								onSelectCenter={(centerId) => this.props.history.push(`/public/timetable?centerId=${centerId}&termId=${selectedTerm.id}&lessonType=${lessonType}&date=${date}`)}
							/>
						</div>
						}
						<div className='clearfix' />
					</Col>
				</Row>
				<Row style={{ paddingTop: '10px' }} className='timetable-options'>
					<Col sm={12}>
						{allowWorkshops && <Link className='btn btn-primary btn-block-xxs pull-right' to={`/public/workshops?centerId=${centerId}`}>{t('FO_MainMenu_Parent_Workshops')} <FontAwesome name='arrow-circle-right' /></Link>}
						<Link className='btn btn-back btn-block-xxs' to={`/public/centers?reset=true&lessonType=${lessonType}`}><FontAwesome name='arrow-circle-left' /> {t('FO_Booking_Center_Select')}</Link>
					</Col>
				</Row>
			</ReduxBlockUi>
		</div>;
	}
}

const mapStateToProps = (state, ownProps) => {
	const { entities: { centers, grades, lessons, terms }, configuration: { franchisor }, parent, auth: { isAuthenticated } } = state;
	const {
		programId,
		date,
		errorMessage,
		childrenPaymentTypes,
		selectedChildId,
		selectedPaymentTypeId,
		isSelectJoinWaitingList,
		annualPaymentLength
	} = state.booking;

	const queryParams = queryString.parse(ownProps.location.search);
	const lessonType = queryParams.lessonType;

	const parentCenterId = parent.centerId;
	const parentCenter = parentCenterId ? centers[parentCenterId] : null;

	let lessonsDeepLoaded = Object.values(lessons);
	lessonsDeepLoaded.forEach(lesson => {
		lesson.grade = grades[lesson.gradeId] || { name: '', subGrades: [] };
		lesson.center = centers[lesson.centerId] || { name: '' };
		lesson.term = terms[lesson.termId] || { name: '', schoolYear: '' };
	});

	const selectedLesson = queryParams.programId && queryParams.startDate && lessons[`${queryParams.programId}@${queryParams.startDate}`];
	if (selectedLesson) {
		selectedLesson.grade = grades[selectedLesson.gradeId] || { name: '' };
		selectedLesson.center = centers[selectedLesson.centerId] || { name: '' };
		selectedLesson.term = terms[selectedLesson.termId] || { name: '', schoolYear: '' };
	}

	const allChildren = state.parent.children;
	allChildren.forEach(child => {
		let ageAppropriateGradeIds = child.ageAppropriateGradeIds || [];
		if (queryParams.centerId && queryParams.termId) {
			ageAppropriateGradeIds = getAgeAppropriateGradesByChild(state.parent, queryParams.centerId, queryParams.termId, child.id) || [];
		}

		child.ageAppropriateGrades = ageAppropriateGradeIds.map(gradeId => grades[gradeId]);
	});

	const selectedCenterId = queryParams.centerId ? Number(queryParams.centerId) : null;
	const selectedCenter = selectedCenterId && centers[selectedCenterId];

	let selectedGradeIds = null;
	if (queryParams.gradeIds) {
		let gradeIdsParamValues = [queryParams.gradeIds];
		if (Array.isArray(queryParams.gradeIds)) {
			gradeIdsParamValues = [...queryParams.gradeIds];
		}
		selectedGradeIds = gradeIdsParamValues.map(id => Number(id));
	}

	const activeLanguage = getActiveLanguage(state.configuration.language);

	return {
		franchisor,
		grades: selectedCenter && selectedCenter.grades ?
			selectedCenter.grades.map(id => grades[id]).filter(x => !!x) : [],
		parentCenter,
		searchParams: {
			city: queryParams.city,
			centerId: selectedCenterId,
			termId: queryParams.termId ? Number(queryParams.termId) : null,
			gradeIds: selectedGradeIds,
			date: queryParams.date,
			lessonType: lessonType || '',	// load all booking options by default - normal and trial
			// selected weekly program item and date to start the booking
			programId: queryParams.programId ? Number(queryParams.programId) : null,
			startDate: queryParams.startDate
		},
		parent,
		centers: Object.values(centers).filter(c => lessonType !== 'trial' || c.isTrialLesson).sort((a, b) => a.name.toUpperCase() < b.name.toUpperCase() ? -1 : 1),
		selectedCenter,
		cities: [...new Set(Object.values(centers).map(center => center.city))],	// distinct list of cities with centers
		lessons: lessonsDeepLoaded,
		selectedLesson,
		terms: selectedCenter && selectedCenter.terms ?
			selectedCenter.terms
				.map(x => ({ ...terms[x.id], ...x }))	 // replace startDate and endDate with actual working period for the selected term
				.filter(x => x.allowBooking)
				.sort(function (a, b) {
					return moment(a.startDate).format('YYYYMMDD') - moment(b.startDate).format('YYYYMMDD');
				})
			: [],
		children: allChildren,
		bookingOptions: {
			programId,
			date,
			lessonType: lessonType || '',
			errorMessage,
			selectedChildId,
			selectedPaymentTypeId,
			isSelectJoinWaitingList,
			annualPaymentLength,
			childrenPaymentTypes: childrenPaymentTypes.map(c => ({
				child: getChild(state.parent, c.childId),
				paymentTypes: c.paymentTypes,
				errorMessage: c.errorMessage,
				joinWaitingList: c.joinWaitingList,
				isLocked: c.isLocked
			}))
		},
		allowWorkshops: franchisor && franchisor.enableWorkshops && Object.values(centers).some(c => c.isWorkshops),
		currentCurrency: activeLanguage && activeLanguage.currencyCode,
		isAuthenticated
	};
};

export default connect(mapStateToProps, {
	loadTermsByCenter,
	loadGradesByCenter,
	loadLessons,
	loadAgeAppropriateGradesByCenterAndTerm,
	loadBookingOptions,
	unselectLesson,
	selectPaymentType,
	startEnrolment,
	selectJoinWaitingList,
	selectChild,
	updateSelectedCenter,
	storeSearchQuery
})(withTranslation()(Timetable));